import * as React from 'react'
import { t } from 'ttag'
import YumButton from '../YumButton/YumButton'

export interface IStateProps {
  buttonText?: string
}

export interface IDispatchProps {
  setOnboardingStatusToActivityData(): void
}

type IProps = IStateProps & IDispatchProps

export default function YumSetupActivityData(props: IProps) {
  return (
    <YumButton size="small" onClick={props.setOnboardingStatusToActivityData}>
      {props.buttonText || t`Start setup`}
    </YumButton>
  )
}
